import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../config/api";

export const fetchUserProfile = createAsyncThunk(
	"customers/getUserProfile",
	async () => {
		const response = await api.get(`/users/profile`);
		return response.data;
	}
);

export const updateUserProfile = createAsyncThunk(
	"customers/updateUserProfile",
	async (data) => {
		const response = await api.put(`/users/updateProfile`, data);
		return response.data;
	}
);

export const updateCrateDB = createAsyncThunk(
	"user/updateCrate",
	async (data) => {
		const response = await api.put(`/users/updateCrate`, data);
		return response.data;
	}
);

export const fetchCrate = createAsyncThunk("user/fetchCrate", async (data) => {
	const response = await api.get(`/users/getCrate/getCrate`, {
		params: data,
	});
	return response.data;
});

export const updateQueueDB = createAsyncThunk(
	"user/updateQueue",
	async (data) => {
		// array of edit's ids from array of tracks
		const editIds = data.tracks.map((track) => track.editInfos[0].id);

		const response = await api.post(`/queue/add`, {
			editIds,
		});
		return response.data;
	}
);

export const removeFromQueueDB = createAsyncThunk(
	"user/removeFromQueue",
	async (data) => {
		// array of edit's ids from array of tracks to remove
		const editIds = data.editIds;
		console.log("Edit IDs to remove:", editIds);

		const response = await api.delete(`/queue/remove`, {
			data: { editIds },
		});
		return response.data;
	}
);

export const fetchQueue = createAsyncThunk("user/fetchQueue", async (data) => {
	const response = await api.get(`/queue/`, {
		params: data,
	});
	return response.data;
});

// Check user eligibility for actions (e.g., downloading a producer pack)
export const checkProducerEligibility = createAsyncThunk(
	"auth/checkProducerEligibility",
	async (packId) => {
		const response = await api.post(`/producer-packs/check-producer-eligibility`, { packId });
		return response.data;
	}
);
